<template>
  <div class="list-div">
    <div class="margins">
      <span>
        <el-button
          @click="addPlan"
          class="base-button"
          size="mini"
          type="primary"
          icon="el-icon-plus"
          >新增</el-button
        >
      </span>
      <span> </span>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      height="640"
      stripe
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column label="序号" type="index" width="50"> </el-table-column>
      <el-table-column prop="planName" label="名称"> </el-table-column>
      <el-table-column prop="planType" label="类型"> </el-table-column>
      <el-table-column prop="data" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="startAction(scope.row)" size="small"
            >推演</el-button
          >
          <el-button type="text" @click="editPlan(scope.row)" size="small"
            >编辑</el-button
          >
          <el-button type="text" @click="backPlan(scope.row)" size="small"
            >备份</el-button
          >
          <el-button type="text" @click="clearAction(scope.row)" size="small"
            >清空</el-button
          >
          <el-button type="text" @click="deleteAction(scope.row)" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import PlanEditor from "./index.vue";
import * as Help from "./Actions/help";
import Workflow from "@/utils/cesiumBD/utils/Workflow";
import {
  createPlanEditor,
  queryPlanEditorList,
  deletePlanEditor,
  queryBdthPlanById,
  copyBdthPlanById,
} from "@/api/planEditor/index.js";
import MilitarySimulation from "./Actions/militarySimulation.js";
export default {
  data() {
    return {
      tableData: [
        {
          planName: "测试预案",
          planType: "消防演练",
          actions: [
            {
              name: "居民点",
              type: "pointModel",
              typeName: "模型标绘",
              delay: 1,
              data: NG_Server + "/gisData/glb/building.glb",
              coordinate: {
                x: -2777208.428375733,
                y: 4674958.127731834,
                z: 3322379.65035633,
              },
              params: {},
              view: {
                y: 31.511205,
                x: 120.67877,
                z: 5718.7,
                heading: 18.9,
                pitch: -25,
                roll: 0,
              },
              complete: true,
            },
            {
              name: "",
              type: "ignitionPoint",
              typeName: "着火点",
              delay: 2,
              data: "http://data.mars3d.cn/gltf/mars/leida.glb",
              coordinate: {
                x: -2777073.411676639,
                y: 4675354.911364691,
                z: 3321944.225208154,
              },
              params: {},
              view: {
                y: 31.590022,
                x: 120.70751,
                z: 51.43,
                heading: 46.6,
                pitch: -8.2,
                roll: 0,
              },
              complete: true,
            },
            {
              name: "危险范围",
              type: "diffusionCircle",
              typeName: "扩散圆",
              delay: 1,
              data: "http://data.mars3d.cn/gltf/mars/leida.glb",
              coordinate: {
                x: -2774084.5072506573,
                y: 4676879.802331458,
                z: 3322302.3107695463,
              },
              params: {},
              view: {
                y: 31.567649,
                x: 120.657592,
                z: 3973,
                heading: 25.2,
                pitch: -49.4,
                roll: 0,
              },
              complete: true,
            },
            {
              name: "救援力量",
              type: "lineRoam",
              typeName: "线路漫游",
              delay: 2,
              data: {
                url: NG_Server + "/gisData/glb/Hoveringdrone.glb",
                time: 5,
              },
              coordinate: [
                {
                  x: -2774166.050679576,
                  y: 4678717.133653988,
                  z: 3319661.379176795,
                },
                {
                  x: -2773954.076090774,
                  y: 4678824.187234413,
                  z: 3319665.9862896125,
                },
                {
                  x: -2773534.8768441873,
                  y: 4677982.275489775,
                  z: 3321194.435107912,
                },
                {
                  x: -2773606.5682184654,
                  y: 4677723.376697399,
                  z: 3321505.055292172,
                },
                {
                  x: -2773762.6373930085,
                  y: 4677595.483484873,
                  z: 3321566.766893434,
                },
                {
                  x: -2774087.0920247133,
                  y: 4676884.249399469,
                  z: 3322278.4032598156,
                },
              ],
              params: {},
              view: {
                y: 31.513691,
                x: 120.620404,
                z: 9686.52,
                heading: 25.2,
                pitch: -49.4,
                roll: 360,
              },
              complete: true,
            },
          ],
        },
      ],
      loading: true,
    };
  },

  mounted() {
    this.$bus.$on("PlanEditor-list", () => {
      this.getList();
    });
  },
  beforeDestroy() {
    this.$bus.$off("PlanEditor-list");
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      queryPlanEditorList()
        .then((res) => {
          this.loading = false;
          this.tableData = res.result;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    addPlan() {
      var ins = this.$dialog.getDialog("新增预案");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "新增预案",
        title: "新增预案",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "600px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: PlanEditor,
        },
      });
    },
    editPlan(row) {
      var ins = this.$dialog.getDialog("预案编辑");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "预案编辑",
        title: "预案编辑",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "600px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: PlanEditor,
          subData: row,
        },
      });
    },
    clearAction() {
      Help.clear();
    },
    startAction(row) {
      queryBdthPlanById(row.id)
        .then((res) => {
          var list = res.result.detail.map((a) => {
            try {
              // 可能会引发异常的代码块
              a.data = JSON.parse(a.data);
            } catch (error) {
              // 异常处理代码块
            }

            a.view = JSON.parse(a.view);
            a.coordinate = JSON.parse(a.coordinate);
            a.params = JSON.parse(a.params);
            return a;
          });

          row.listMain = list;
          MilitarySimulation.start(list);
          // Help.clear();
          // var funs = [];
          // for (let i = 0; i < list.length; i++) {
          //   funs.push({
          //     fun: this.createPromise,
          //     delay: list[i].delay * 1000,
          //     params: list[i],
          //   });
          // }

          // var ws = new Workflow(funs);
          // ws.runWorkflow();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    createPromise(item) {
      item.complete = false;
      var type = item.type;
      let view = item.view;
      let opts = {};
      opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度
      opts.orientation = {
        heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
        pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
        roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)), //绕经度线旋转
      };

      opts.complete = function () {
        item.complete = true;
      };

      return new Promise((resolve) => {
        viewer.camera.flyTo(opts);
        Help["action_" + type](item);
        let timer = setInterval(() => {
          if (item.complete) {
            resolve();
            clearInterval(timer);
          }
        }, 100);
      });
    },
    deleteAction(row) {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletePlanEditor(row.id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("PlanEditor-list");
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    backPlan(row) {
      this.loading = true;
      copyBdthPlanById(row.id).then(() => {
        this.loading = false;
        this.$message({
          showClose: true,
          message: "备份成功！",
          type: "success",
          duration: 3 * 1000,
        });
        this.$bus.$emit("PlanEditor-list");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-div {
  padding: 20px;
  .margins {
    margin-bottom: 16px;
  }
}
</style>
